import React, { useEffect, useState } from 'react'

import { append, isEmpty } from 'ramda'

import { Button } from '@driftt/dds'
import { A, CardContainer, CircleLoader, Div, P } from '@driftt/tide-core'

import useNotifications from 'hooks/useNotifications'

import { fetchSendingDomains } from './api'
import CreateDomainModal from './CreateDomainModal'
import Domain from './Domain'

import './style.css'

const Loader = () => (
  <Div className="email-sending-domains-loading">
    <CircleLoader size="large" />
    <Div className="email-sending-domains-loading--text">
      Loading your email domains...
    </Div>
  </Div>
)
const EmailSendingDomains = () => {
  const [sendingDomains, setSendingDomains] = useState(null)
  const [fetchSendingDomainsError, setFetchSendingDomainsError] =
    useState(false)
  const [creatingDomain, setCreatingDomain] = useState(null)
  const { error, success } = useNotifications()

  useEffect(() => {
    if (!sendingDomains) {
      fetchSendingDomains()
        .then((res) => setSendingDomains(res))
        .catch((err) => {
          setFetchSendingDomainsError(true)
          error('An error occurred while fetching your domains')
          console.error(err)
        })
    }
  }, [sendingDomains, error])

  const isLoading = !sendingDomains && !fetchSendingDomainsError
  const validSendingDomains = !!sendingDomains && !isEmpty(sendingDomains)

  const handleCreatedDomain = (newSendingDomain) => {
    setCreatingDomain(null)
    setSendingDomains(append(newSendingDomain, sendingDomains))
    success('Successfully created sending domain')
  }

  return (
    <>
      <Div className="email-sending-domains-wrapper">
        <Button
          className="email-sending-domains--add-domain-button"
          onClick={() => setCreatingDomain(true)}
          css={{
            position: 'absolute',
            top: '-58px',
            right: '32px',
          }}
        >
          Add domain
        </Button>
        <CardContainer header="All domains" padding="large">
          <P>
            Authenticate your domains with Drift by modifying your domain's DNS
            records. These changes allow your campaigns to appear to come from
            your email domain, instead of from our servers. After you've made
            the required DNS changes, please wait 24-48 hours for the changes to
            propagate.{' '}
            <A
              href="https://help.salesloft.com/s/article/Setting-Up-Email-Sending-Domains-DKIM"
              target="_blank"
            >
              Learn more
            </A>
          </P>
          {isLoading && <Loader />}
          {validSendingDomains &&
            sendingDomains.map((sendingDomain) => (
              <Domain
                key={sendingDomain.id}
                allSendingDomains={sendingDomains}
                setSendingDomains={setSendingDomains}
                sendingDomain={sendingDomain}
              />
            ))}
        </CardContainer>
      </Div>
      {creatingDomain && (
        <CreateDomainModal
          onClose={() => setCreatingDomain(null)}
          onCreate={handleCreatedDomain}
        />
      )}
    </>
  )
}

export default EmailSendingDomains
